import { useEffect, useState } from "react"
import Base from "../../Base/views/Base"
import Box from '@mui/material/Box';
import { Button, Card, Grid, IconButton, Link, TextField, Typography } from "@mui/material";
import table from "../../assets/table1.jpg"
import DeleteIcon from '@mui/icons-material/Delete';
import Popup from "../../components/Popup";
import Swal from "sweetalert2";
import axiosInstance from "../../../axiosInstance";

const TableLandingPage = () => {

    const [hotelID] = localStorage.getItem("billing_app_hotel")
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const initialValues = {
        name: "",
        capacity: "",
        hotel: ""
    }
    const [inputData, setInputData] = useState(initialValues)
    const [errors, setErrors] = useState(initialValues)

    useEffect(() => {
        getData()
        //eslint-disable-next-line
    }, [])

    const getData = () => {
        axiosInstance(`/api/table/?hotel=${hotelID}`, {
            method: "GET"
        }).then(res => {
            setData(res.data)
        }).catch(err => {
            console.log(err)
        })
    }

    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("name" in fieldValues) {
            temp.name =
                fieldValues.name === "" || null ? "Name is required" : "";
        }
        if ("capacity" in fieldValues) {
            temp.capacity =
                fieldValues.capacity === "" || null ? "Capacity is required" : "";
        }

        setErrors({ ...temp });
        return Object.values(temp).every((x) => x === "");
    };

    const handleChange = (e) => {
        setInputData({ ...inputData, [e.target.name]: e.target.value })
    }

    const handleClose = () => {
        setOpen(false);
        setInputData(initialValues);
    }

    const handleSubmit = () => {
        let api = inputData?.id ? `/api/table/${inputData.id}/` : `/api/table/`;
        let method = inputData?.id ? "PUT" : "POST";
        if (validate(inputData)) {
            axiosInstance(api, {
                method: method,
                data: {
                    name: inputData.name,
                    capacity: inputData.capacity,
                    hotel: hotelID
                }
            }).then(res => {
                getData();
                setInputData(initialValues);
                setErrors(initialValues);
                setOpen(false);
            }).catch(err => {
                console.log(err)
            })
        }
    }

    const handleClick = (res) => {
        setOpen(true);
        setInputData(res);
    }

    const handleDelete = (e, id) => {
        e?.stopPropagation();
        Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this Table?",
            showDenyButton: false,
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Delete Table",
            icon: 'warning',
            reverseButtons: true,

        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance(`/api/table/${id}/`, {
                    method: "DELETE"
                }).then(res => {
                    getData();
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Table has been deleted successfully',
                        showConfirmButton: true,
                        timer: 1500
                    })
                }).catch(err => {
                    console.log(err)
                })
            }
        })


    }

    return (
        <Base>
            <Popup
                open={open}
                handleClose={handleClose}
                title={"Add Table"}
                handleSubmit={() => handleSubmit()}
                maxWidth="sm"
            >
                <Box sx={{ mt: 2, mb: 2 }}>
                    <TextField
                        label="Table Name"
                        fullWidth
                        required
                        name="name"
                        onChange={handleChange}
                        autoFocus={true}
                        value={inputData?.name || ""}
                        size="small"
                        sx={{ mt: 2 }}
                        {...(errors.name && {
                            error: true,
                            helperText: errors.name,
                        })}
                    />
                    <TextField
                        label="Capacity"
                        type="number"
                        fullWidth
                        required
                        name="capacity"
                        onChange={handleChange}
                        value={inputData?.capacity || ""}
                        size="small"
                        sx={{ mt: 2 }}
                        {...(errors.capacity && {
                            error: true,
                            helperText: errors.capacity,
                        })}
                    />
                </Box>
            </Popup>

            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: 2 }}>
                <Button 
                    variant="contained" 
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{ 
                        borderRadius: 1.5,
                        px: 2,
                        py: 0.75,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(139, 68, 255, 0.3)',
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(139, 68, 255, 0.4)',
                            transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.3s ease',
                    }}
                >
                    Add Table
                </Button>
            </Box>

            <Box sx={{ flexGrow: 1, mt: 2 }}>
                <Grid container spacing={2}>
                    {data?.map((res) => (
                        <Grid item xs={12} sm={6} md={4} key={res.id}>
                            <Card
                                variant="outlined"
                                sx={{
                                    width: "100%",
                                    maxWidth: 350,
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    borderRadius: 2,
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
                                    "&:hover": {
                                        boxShadow: '0 4px 12px rgba(139, 68, 255, 0.15)',
                                        transform: "translateY(-3px)",
                                        borderColor: "primary.main",
                                    },
                                    cursor: "pointer",
                                    overflow: "hidden",
                                    p: 0,
                                    bgcolor: "#fff",
                                    border: '1px solid rgba(0, 0, 0, 0.08)',
                                }}
                                onClick={() => handleClick(res)}
                            >
                                <Box>
                                    <img
                                        src={res?.image || table}
                                        alt="table"
                                        style={{
                                            width: "100%",
                                            height: 180,
                                            objectFit: "cover",
                                        }}
                                        loading="lazy"
                                    />
                                </Box>
                                <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            {res?.name}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                            Capacity: {res?.capacity}
                                        </Typography>
                                    </Box>
                                    <IconButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDelete(e, res?.id);
                                        }}
                                        aria-label="delete"
                                        size="small"
                                    >
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {data?.length === 0 && (
                <Box 
                    sx={{ 
                        mt: 8, 
                        textAlign: "center",
                        py: 8,
                    }}
                >
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            color: 'text.secondary',
                            mb: 2,
                            fontWeight: 500,
                        }}
                    >
                        No Tables yet
                    </Typography>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            color: 'text.secondary',
                            mb: 4,
                        }}
                    >
                        Create your first table to start managing orders
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={() => setOpen(true)}
                        sx={{
                            borderRadius: 2,
                            px: 4,
                            py: 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        Create New Table
                    </Button>
                </Box>
            )}
        </Base>


    )
}

export default TableLandingPage